import React, { FC } from 'react';

import { HarvestSummaryTabProps } from './HarvestSummary.props';

import HarvestSummaryTabContent from './HarvestSummaryTabContent';
import { InventoryReportStatusEnum } from 'types/report';
const InReviewSummary: FC<HarvestSummaryTabProps> = (props) => {
  const { counts, ...data } = props;

  const filteredCounts = counts.filter((count) => {
    return count.status === InventoryReportStatusEnum.IN_REVIEW;
  });
  return <HarvestSummaryTabContent counts={filteredCounts} {...data} />;
};

export default InReviewSummary;
